import React from 'react'
import { Icon, Popup, Dropdown, Label } from 'semantic-ui-react'

import CreditStatusColor from '../../../helpers/CreditStatus'
import BatteryStatus from '../../../helpers/BatteryStatus'
import OrderRangeStatuColor from '../../../helpers/OrderRangeStatus'

const styles = {
  wrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
  },
  telWrapper: {
    width: 150,
    whiteSpace: 'normal',
    wordBreak: 'break-all',
    lineHeight: '1.3',
    marginLeft: 5,
  },
}

export default class DriverListItem extends React.PureComponent {
  getStatusColor = status => {
    switch (status) {
      case 'busy':
        return 'red'
      case 'available':
        return 'green'
      case 'waiting_for_confirm':
        return 'yellow'
      default:
        return 'gray'
    }
  }

  render() {
    const { index, driver, todayOrders } = this.props
    const name = `${index + 1}. ${driver.family_name} ${driver.first_name}`

    return (
      <Dropdown.Item value={driver.tel}>
        <div style={styles.wrapper}>
          <div style={{ display: 'flex' }}>
            {driver.status && <Label circular color={this.getStatusColor(driver.status)} empty />}
          </div>
          <div style={styles.telWrapper}>
            <Popup trigger={<div>{name}</div>} position="top center">
              {driver.tel}
            </Popup>
          </div>
          <div style={{ display: 'flex' }}>
            <Label size="medium" style={{ marginLeft: 10, textAlign: 'center' }}>
              <Icon name="box" />
              {driver.package_size && driver.package_size.substring(0, 1).toUpperCase()}
            </Label>
          </div>
          <div style={{ display: 'flex' }}>
            <Label
              size="medium"
              color={CreditStatusColor(driver.credit_balance || 0)}
              style={{
                marginLeft: 10,
                textAlign: 'center',
                maxWidth: 100,
                minWidth: 70,
              }}
            >
              {`$ ${parseFloat(driver.credit_balance || 0).toFixed(2)}`}
            </Label>
          </div>
          <div style={{ display: 'flex' }}>
            <Label
              size="medium"
              color={BatteryStatus(driver.battery).color}
              style={{
                marginLeft: 10,
                textAlign: 'center',
                maxWidth: 100,
                minWidth: 70,
              }}
            >
              <Icon name={BatteryStatus(driver.battery).icon} />
              {parseInt(driver.battery * 100, 10)}%
            </Label>
          </div>
          <div style={{ display: 'flex' }}>
            <Label
              size="medium"
              color={OrderRangeStatuColor(todayOrders)}
              style={{ marginLeft: 10, textAlign: 'center' }}
              circular
            >
              {todayOrders}
            </Label>
          </div>
        </div>
      </Dropdown.Item>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/DriverListItem.js